package com.mgacreative.hotel.core.tenant

enum class UserRole {
    SUPER_ADMIN,
    HOTEL_OWNER,
    MANAGER,
    RECEPTION,
    HOUSEKEEPING,
    ACCOUNTING,
    STAFF,
    UNKNOWN
}
